const overseasActivityNewsRouter = {
  title: '活动预告管理',
  type: 'view',
  name: 'overseasActivityNewsList',
  route: '/overseas-activity-news/list',
  filePath: 'view/overseas_activity_news/list.vue',
  order: 6,
  inNav: true,
  icon: 'iconfont el-icon-date',
  permission: ['查询活动资讯'],
}

export default overseasActivityNewsRouter
